export const ToolBtn: React.FC<{
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ title, onClick, children }) => (
  <button
    type="button"
    title={title}
    onMouseDown={(e) => { e.preventDefault(); onClick(); }}
    className="w-7 h-7 flex items-center justify-center text-xs text-gray-600 hover:bg-gray-200 rounded transition-colors"
  >
    {children}
  </button>
);
